import type { RoadmapListResponseRoadmapsItemCreatorBasicInfo } from './roadmapListResponseRoadmapsItemCreatorBasicInfo';
import type { RoadmapListResponseRoadmapsItemCreatorSocial } from './roadmapListResponseRoadmapsItemCreatorSocial';

/**
 * 로드맵 생성자 정보
 */
export type RoadmapListResponseRoadmapsItemCreator = {
  /** 사용자 기본 정보 */
  basicInfo: RoadmapListResponseRoadmapsItemCreatorBasicInfo;
  /** 소셜 관계 정보 */
  social?: RoadmapListResponseRoadmapsItemCreatorSocial;
};
